jQuery(document).ready(function ($) {


    $('.ContentIntelligence-slide').slick({
        dots: false,
        infinite: true,
        speed: 800,
        slidesToShow: 1,
        adaptiveHeight: false,
        arrows: true,
        fade: true,
        prevArrow: $('.slick-prev'),
        nextArrow: $('.slick-next'),
        cssEase: 'linear',
    });
    const animationRemote1 = bodymovin.loadAnimation({
        container: document.getElementById('svg__0001'),
        path: '/wp-content/themes/beaverwarrior/components/ContentIntelligence/bw-content-intelligence/includes/img/jsonencompass_9s_2000x2000_v3.json',
        autoplay: true,
        renderer: 'svg',
        loop: true
    });
});
